import { render, staticRenderFns } from "./AppointmentAcceptConfirm.vue?vue&type=template&id=a3993048&"
import script from "./AppointmentAcceptConfirm.vue?vue&type=script&lang=ts&"
export * from "./AppointmentAcceptConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports